var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[(_vm.linkTo)?_c('a',{staticClass:"el-route-link",attrs:{"href":"javascript:;"},on:{"click":_vm.link}},[_vm._t("default")],2):_c('a',{staticClass:"el-route-link",attrs:{"href":"javascript:;"}},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }